<ngx-highlight-words
	[textToHighlight]="Text"
	[searchWords]="[highlightTerm]"
	highlightClassName="highlight-search">
	<!-- [sanitize]="removeDiacritics" //TODO: erro de sintaxe no pacote npm causando erro na hora de compilar, sanitize não recebe parametro e o retorno é void -->
</ngx-highlight-words>